import { mogamboRequestV2 } from '@src/api/utils';
import { BASE_URL } from '@src/const';

export const fetchDynamicMessage = businessId => {
  const url = `${BASE_URL}business/dynamic_message/?business_id=${businessId}`;
  const response = mogamboRequestV2(url, 'GET');
  return Promise.resolve(response);
};

export const saveDynamicMessage = data => {
  const url = `${BASE_URL}business/dynamic_message/`;
  const response = mogamboRequestV2(url, 'POST', data);
  return Promise.resolve(response);
};
